import { ChildrenDOMType, } from '@tencent/exeditor3-core';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export const inputRegex = /^\s*>\s$/gm;
export class QuotePlugin {
    constructor() {
        this.name = 'quote';
        this.spec = {
            defining: true,
            type: 'node',
            childrenType: ChildrenDOMType.BLOCK,
            matchSelector: 'blockquote',
            toDOM: 'blockquote',
        };
        this.isActive = () => this.editor.isActive(this);
        this.toggle = () => {
            this.editor.selection(true).toggleWrappingBlock(this);
        };
    }
    capabilities() {
        return {
            commands: {
                toggle: this.toggle,
                isActive: this.isActive,
            },
            shortcuts: {
                'Mod-Shift-9': this.toggle,
                // 暂时兼容旧的热键
                'Mod-Shift-b': this.toggle,
            },
            inputRules: [inputRegex],
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('引用'),
            shortcut: 'Mod-Shift-9',
            onclick: () => {
                this.editor.focus();
                this.toggle();
            },
        }).append(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.quoteIcon),
        }));
        const setBtnStatus = () => {
            btn.active = this.isActive();
        };
        this.editor.on('idlechange', setBtnStatus);
        return btn;
    }
}
//# sourceMappingURL=index.js.map